jQuery(document).ready(function ($) {
  // Pointer Events Polyfill
  if (window.requestAnimationFrame) {
    $("html").addClass("gt-ie9");
  }

  $("#front-div").click(function (e) {
    $(this).hide();
    $(document.elementFromPoint(e.clientX, e.clientY)).trigger("click");
    $(this).show();
  });

  function passThrough(e) {
    $("a").each(function () {
      var mouseX = e.pageX,
        mouseY = e.pageY,
        offset = $(this).offset(),
        width = $(this).width(),
        height = $(this).height();

      if (
        mouseX > offset.left &&
        mouseX < offset.left + width &&
        mouseY > offset.top &&
        mouseY < offset.top + height
      ) {
        window.location = $(this).attr("href");
      }
    });
  }

  $(".lt-ie10 #front-div, .gt-ie9 #front-div").click(passThrough);

  // add item to cart
  $("a.add-item").click(function (e) {
    e.preventDefault();
    if ($(this).parents("form").has(".options")) {
      var button_content = $(this).parents("form").find("button").text();
      if (button_content == "Options for this product") {
        $(this).parents("form").find(".error").show();
      } else {
        $(this).closest("form").submit();
      }
    } else {
      $(this).closest("form").submit();
    }
  });

  // choosing a product option (product template)
  $("select#variant").change(function () {
    var variant_id = $(this).val();
    $(this).parents("form").find('input[name="id"]').val(variant_id);
  });

  // product details switch main image
  $(".product-detail .thumbs img").mouseenter(function () {
    var src = $(this).attr("src");
    $(".product-detail .main-image img").attr("src", src);
  });

  // hide input placeholder on focus
  $("input, textarea").each(function (index) {
    var placeholder = $(this).attr("placeholder");
    $(this)
      .data("placeholder", placeholder)
      .focus(function () {
        $(this).attr("placeholder", "");
      })
      .blur(function () {
        if ($(this).val() == "") {
          $(this).attr("placeholder", $(this).data("placeholder"));
        }
      });
  });

  // update cart total
  $(".cart input").keyup(function () {
    var val = $(this).val();

    if (val != "") {
      cartTotal();
    }
  });

  function cartTotal() {
    var total = 0;

    $(".cart input").each(function () {
      var val = $(this).val();
      var price = $(this).parents(".item").attr("data-price");
      total += val * price;
    });

    $(".total").text("$" + total);
  }
  cartTotal();

  // Toggle Dots
  $("a.toggle-dots").click(function (e) {
    e.preventDefault();

    $(".circle-pattern").toggle();
  });

  // Smooth Scroll
  // $("a[href^='#']").click(function (e) {
  //   e.preventDefault();

  //   var position = $($(this).attr("href")).offset().top;

  //   $("body, html").animate(
  //     {
  //       scrollTop: position,
  //     } /* speed */
  //   );
  // });
});

document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const overlay = document.querySelector(".mobile-menu-overlay");

  if (!overlay) return;

  const observer = new MutationObserver(() => {
    body.style.overflow = overlay.classList.contains("active") ? "hidden" : "";
  });

  observer.observe(overlay, { attributes: true, attributeFilter: ["class"] });
});
